import { render, staticRenderFns } from "./UpcomingEvents.vue?vue&type=template&id=d00aa170&scoped=true"
import script from "./UpcomingEvents.vue?vue&type=script&lang=js"
export * from "./UpcomingEvents.vue?vue&type=script&lang=js"
import style0 from "./UpcomingEvents.vue?vue&type=style&index=0&id=d00aa170&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d00aa170",
  null
  
)

export default component.exports